export default "__VITE_ASSET__6cfe90fd__"